export default {"src":"/_next/static/media/default.941f0cfd.svg","height":18,"width":194,"blurWidth":0,"blurHeight":0};